import http, {configForm} from "../config/http-configs";
import {configJson} from "@/api/config/http-configs";


export const confirmCheckOut = (applyId, visitorIds) => {
    const url = `/mobile/record/confirm?applyId=${applyId}&visitorIds=${visitorIds}`
    return http.post(url, null, configForm)
}


export const getValidRecords = () => {
    return http.get('/mobile/record/list/employee/valid')
}

export const getInvalidRecordsByPage = (pageIndex, pageSize= 20) => {
    const url = '/mobile/record/list/employee/invalid'
    const page = {"current": pageIndex, "size": pageSize}
    return http.post(url, page, configJson)
}


// /manage/record/check/state
export const mobileCheckRecordState = (applyId, visitorCodeList, enterDate) => {
    const url = '/mobile/record/check/state'
    const data = {applyId: applyId, visitorCodes: visitorCodeList, enterDate: enterDate}
    return http.post(url, data, configJson)
}
